// Generated with util/create-component.js
import Table from './Table';

export default Table;
